import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateEventList} from '#core/application/modules/tiles/event-list/index.js';

import EVENTS_COUPON from './events-coupon.palette-schema.yaml';

registerTileSchema(EVENTS_COUPON);

export function generateEventsCoupon(TILE) {
    return {
        container: {
            style: {
                _mobile_flexDirection: 'column',
            },
        },
        eventListSkeleton: {
            container: {
                style: {
                    padding: 'inherit',
                },
            },
        },
        eventList: generateEventList(TILE.EVENTS_COUPON_EVENT_LIST),
    };
}
